
// ACADEMIC YEARS
export const GET_ACADEMIC_YEARS = "/academic-years";
export const GET_ACTIVE_ACADEMIC_YEARS = "/academic-years/active";
export const ADD_NEW_ACADEMIC_YEAR = "/academic-years";
export const UPDATE_ACADEMIC_YEAR = "/academic-years";
export const DELETE_ACADEMIC_YEAR = "/academic-years";


